// busting script for older browsers to prevent cross frame scripting
const server = window.location.href.substring(0, window.location.href.indexOf('/', 10));
try {
  if (top.location.href.indexOf(server) !== 0) {
    top.location.replace(server);
  }
} catch (e) {
  // not able to access top frame because of domain
  window.open(server, '_top');
}

//IE11 polyfill
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode === null) {
          return;
        }
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


document.addEventListener('DOMContentLoaded', () => {
  // check if page from CAS server
  if (window.location.href.indexOf('?ticket=') > 0) {
    // redirect to top frame
    top.location.replace('/users/api/login-redirect');
    return;
  }

  let loginlink = null;
  let gLanguage = 'en';

  if (document.body.classList.contains('lang-es')) {
    gLanguage = 'es';
  }

  // check if the footer is displayed
  if (document.getElementById('block-footerthird') === null) {
    return; 
  }

  if (gLanguage === 'es') {
    loginlink = document.getElementById('block-footerthird').querySelector('a[href="/es/inicio-de-sesion-de-cas"]');
  } else {
    loginlink = document.getElementById('block-footerthird').querySelector('a[href="/cas-login"]');
  }
  // Check if user has access to mail inquiry system
  if (document.cookie.indexOf('ncreplyuser=true') > -1) {
    loginlink.parentElement.insertAdjacentHTML('beforebegin', '<li id="nc-reply-link"><a href="/nc-reply">Mail Inquiries</a></li>');
  }
  // Check to see if the user is a drupal admin user
  if (document.cookie.indexOf('drupaluser=true') > -1) {
    loginlink.parentElement.insertAdjacentHTML('beforebegin', '<li id="drupal-link" ><a href="/cas-login">ECLKC Content Management</a></li>');
  }
  if (document.cookie.indexOf('browserlogin=true') > -1) {
    // Check that the user is still logged into CAS
    var casRegex = /Central Authentication Service/g;

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        // User has been logged out of cas! Change cookies accordingly
        const response = xhr.responseText;
        if (response.match(casRegex)) {
          if (document.cookie.indexOf('ncreplyuser=true') > -1) {
            document.getElementById('nc-reply-link').remove();
          }
          // Check to see if the user is a drupal admin user
          if (document.cookie.indexOf('drupaluser=true') > -1) {
            document.getElementById('drupal-link').remove();
          }
          document.cookie = 'ncreplyuser=false;path=/';
          document.cookie = 'drupaluser=false;path=/';
          document.cookie = 'logoutURL=false;path=/';
          document.cookie = 'browserlogin=false;path=/';

          loginlink.addEventListener('click', e => {
            const protocol = location.protocol;
            const slashes = protocol.concat('//');
            const host = slashes.concat(window.location.host);
            // use full page
            if (window.location.href.indexOf('/users/') > 0 || window.location.href.indexOf('service=') > 0) {
              e.target.href = '/cas/login?service=' + encodeURIComponent(host + (gLanguage === 'es' ? '/es' : '/')) + '&locale=' + gLanguage;
            } else {
              e.target.href = '/cas/login?service=' + encodeURIComponent(window.location.href) + '&locale=' + gLanguage;
            }
          });
        } else {
          if (gLanguage === 'es') {
            loginlink.parentElement.insertAdjacentHTML('beforebegin', '<li><a href="/users/api/profile?locale=es">Perfil</a></li>');
          } else {
            loginlink.parentElement.insertAdjacentHTML('beforebegin', '<li><a href="/users/api/profile">Profile</a></li>');
          }
          loginlink.textContent = gLanguage === 'es' ? 'Cerrar sesión' : 'Logout';
          var logoutURL = getLogoutURL();
          loginlink.href = logoutURL;
        }
      }
    };
    xhr.open('GET', '/users/api/profile?loginStatus');
    xhr.send();
  } else {
    loginlink.addEventListener('click', e => {
      const protocol = location.protocol;
      const slashes = protocol.concat('//');
      const host = slashes.concat(window.location.host);
      // use full page
      if (window.location.href.indexOf('/users/') > 0 || window.location.href.indexOf('service=') > 0) {
        e.target.href = '/cas/login?service=' + encodeURIComponent(host + (gLanguage === 'es' ? '/es' : '/')) + '&locale=' + gLanguage;
      } else {
        e.target.href = '/cas/login?service=' + encodeURIComponent(window.location.href) + '&locale=' + gLanguage;
      }
    });
  } 
});

/**
 * Gets the HSES logoutURL, if it exists
 * @return {String} - the logout url
 */
function getLogoutURL () {
  let url;
  try {
    const cookies = document.cookie.split(';');
    url = '/cas/logout';
    for (let i = 0; i < cookies.length; i++) {
      if (cookies[i].match(/logoutURL/g)) {
        const address = cookies[i].replace('logoutURL=', '').trim();
        if (address && address.length && address !== 'false') {
          url = address;
          if (url.indexOf('%2F') > 0) {
            url = decodeURIComponent(url);
          }
        }
        break;
      }
    }
  } catch (e) {
    return url;
  }
  return url;
}
